<template>
  <div v-loading="loading">
    <div class="title">我的挑战</div>
    <div class="search-box">
      <el-select
        class="w-200 mr-12"
        remote
        placeholder="关联任务"
        v-model="task"
        filterable
        clearable
        :remote-method="handleRemote"
        :loading="searchLoading"
        size="medium"
      >
        <el-option
          v-for="(item, index) in taskList"
          :key="index"
          :value="item.id"
          :label="item.name"
        ></el-option>
      </el-select>
      <el-select
        placeholder="状态"
        v-model="status"
        clearable
        size="medium"
        class="w-200 mr-12"
      >
        <el-option :value="1">待提交</el-option>
        <el-option :value="2">已提交</el-option>
        <el-option :value="3">已通过</el-option>
        <el-option :value="4">已拒绝</el-option>
      </el-select>
      <el-input
        v-model="challengeName"
        placeholder="挑战名称"
        size="medium"
        class="w-200 mr-12"
      ></el-input>
      <el-cascader
        v-model="common_industry_id"
        :options="industryList"
        :props="optionProps"
        placeholder="请选择行业分类"
        size="medium"
        class="w-132 mr-12"
        @change="search"
        clearable
      ></el-cascader>
      <el-button size="medium" type="primary" @click="search" plain
        >查询</el-button
      >
      <el-button size="medium" @click="handleReset">重置</el-button>
    </div>
    <el-table :data="list" :stripe="true">
      <el-table-column
        label="挑战名称"
        prop="name"
        width="140"
      ></el-table-column>
      <el-table-column label="关联任务">
        <template slot-scope="scope">
          {{ (scope.row.task || {}).name }}
        </template>
      </el-table-column>
      <el-table-column label="应用场景">
        <template slot-scope="scope">
          <div>
            <div v-for="item in scope.row.use_cases" :key="item">
              {{ item == 1 ? "实战营" : "赛训" }}
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="100">
        <template slot="header">
          <div @click="toggleShowContent" class="toggle-show">
            <span>最终价格</span>
            <i class="el-icon-view toggle-show-icon"></i>
          </div>
        </template>
        <template slot-scope="scope">
          <show-hide-content
            :value="
              scope.row.teacher_production_price
                ? scope.row.teacher_production_price
                : '-'
            "
            :show.sync="isShow"
          ></show-hide-content>
        </template>
      </el-table-column>
      <el-table-column label="关联行业" width="100" show-overflow-tooltip>
        <template slot-scope="scope">
          {{
            (scope.row.common_industries || []).length
              ? String(
                  scope.row.common_industries.map(data => {
                    return data.name;
                  })
                )
              : "-"
          }}
        </template>
      </el-table-column>
      <el-table-column label="截止时间" width="120">
        <template slot-scope="scope">
          {{ (scope.row.task || {}).end_at.substring(0, 10) }}
        </template>
      </el-table-column>
      <el-table-column
        label="创建时间"
        width="120"
        prop="created_at"
      ></el-table-column>
      <el-table-column
        label="当前状态"
        width="100"
        prop="status_label"
      ></el-table-column>
      <el-table-column label="操作" width="100" fixed="right">
        <template slot-scope="scope">
          <el-link :underline="false" @click="handleGoDetail(scope.row.id)"
            >详情</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total, prev, pager, next, jumper"
      @current-change="goPage"
      :current-page.sync="pagination.currentPage"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      :hide-on-single-page="true"
    >
    </el-pagination>
  </div>
</template>

<script>
import challengeService from "@/global/service/challenge";
import kcellService from "@/global/service/kcell";
import ShowHideContent from "@/components/ShowHideContent";
export default {
  components: {
    ShowHideContent
  },
  data() {
    return {
      searchLoading: false,
      taskList: [],
      task: null,
      challengeName: null,
      status: null,
      pagination: {
        total: 0,
        pageSize: 10,
        currentPage: 1
      },
      list: [],
      loading: false,
      isShow: false,
      common_industry_id: null,
      industryList: [],
      optionProps: {
        value: "id",
        label: "name",
        children: "children",
        emitPath: false
      }
    };
  },
  created() {
    this.getData();
    this.getTask();
    this.getConst();
  },
  watch: {
    $route() {
      this.getData();
    }
  },
  methods: {
    getData() {
      this.loading = true;
      const params = {
        name: this.challengeName,
        challenge_task_id: this.task,
        status: this.status,
        page: this.pagination.currentPage,
        page_size: this.pagination.pageSize,
        common_industry_id: this.common_industry_id
      };
      challengeService
        .myChallengeList(params)
        .then(res => {
          res.list.forEach(data => {
            data.created_at = data.created_at.substring(0, 10);
          });
          this.list = res.list;
          this.pagination.total = res.pagination.total;
          this.pagination.currentPage = res.pagination.current_page;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getTask() {
      challengeService.myChallengeTaskAll().then(res => {
        this.taskList = res;
      });
    },
    getConst() {
      kcellService.kcellIndustry().then(res => {
        this.industryList = res;
      });
    },
    search() {
      this.getData();
    },
    handleReset() {
      this.task = null;
      this.challengeName = null;
      this.status = null;
      this.common_industry_id = null;
      this.getData();
    },
    handleRemote() {},
    goPage(current) {
      this.pagination.currentPage = current;
      this.$router.push({
        name: "ChallengeMySelf",
        query: {
          page: current
        }
      });
    },
    handleGoDetail(id) {
      this.$router.push({
        name: "ChallengeDetail",
        params: {
          id
        }
      });
    },
    toggleShowContent() {
      this.isShow = !this.isShow;
    },
    handleGoEdit(id) {
      this.$router.push({
        name: "ChallengeEdit",
        params: {
          id
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.search-box {
  display: flex;
  margin-bottom: 20px;
}
</style>
